import React from "react";

const FormHeader = () => {
  return (
    <header id="FormHeader" className="papercraft pc-pagehero">
      <div className="pc-pagehero__inner">
        <span className="pc-eyebrow">Personalize</span>
        <h1 className="pc-pagehero__title">
          Your <em>request</em> form.
        </h1>
        <p className="pc-pagehero__lede">
          Fill in the details below and we'll craft your invitation — music,
          animations and all — into a personalized link to send to loved ones.
        </p>
      </div>
    </header>
  );
};

export default FormHeader;